import React from "react";

const AboutSection = () => {
  return (
    <div className="flex-1">
      <h2 className="text-2xl font-bold text-[#003132] mb-4">HAKKIMIZDA</h2>
      <p className="text-gray-800 leading-relaxed">
        Cinsleri gözetmeksizin her türde ve cinsteki halılar her mevsim Profesyonelce çalışan kurumsal firmalarda yıkatılmalıdır. Firmamız deneyimli personel ve modern makinaları ile siz değerli müşterilerimize 4 mevsim hizmet vermek için kurulmuştur. Kapınızda kredi kartı ile ödeme yapabilirsiniz. Antibakteriyel, antistatik, antialerjik, bitkisel halı şampuanı tatbik edilerek endüstriyel fırça makinesi ile ön ve arka yüzü optimum oranda fırçalanarak kirlerin çözülmesi ve halınızın hijyenik olması sağlanır. Hav aralarındaki kir ve diğer maddelerin üste çıkması için su hortumu halının altına alınarak kir atıcı yoğun gelberi uygulamasına başlanır. Bu işleme hav tabandan temiz su elde edilinceye kadar devam edilir. Yine iŞçilik faktörü bu aşamada oldukça önem arz eder. Su hortumu halının üstüne alınarak gelberi uygulamasına durulama ile birlikte devam edilir. Yıkama işlemi bu sayede bitirilmiş olunur..
      </p>
    </div>
  );
};

export default AboutSection;